/**
 * Enterprise Notification Center - Type Definitions
 * This is the in-app toast/popup notification system, separate from
 * the bell-icon app notifications stored in the database.
 */

export type NotificationType =
 |"success" | "info" | "warning" | "error" | "system" | "security" | "task" | "project" | "leave" | "time";

export type NotificationPriority = "low" | "normal" | "high" | "critical";

export interface Notification {
 id: string;
 type: NotificationType;
 title: string;
 message?: string;
 timestamp: number;
 isRead: boolean;
 isDismissed: boolean;
 priority: NotificationPriority;
 actionUrl?: string;
 actionLabel?: string;
 /** Auto-dismiss timeout in ms. 0 = no auto-dismiss */
 duration: number;
 /** Internal state for animation */
 phase: "entering" | "visible" | "exiting";
}

export interface NotificationOptions {
 title: string;
 message?: string;
 type?: NotificationType;
 priority?: NotificationPriority;
 duration?: number;
 actionUrl?: string;
 actionLabel?: string;
}

/** Notification center display settings */
export interface NotificationCenterConfig {
 maxVisible: number;
 position: "top-right" | "top-center" | "bottom-right";
 defaultDuration: number;
}

export const DEFAULT_CONFIG: NotificationCenterConfig = {
 maxVisible: 5,
 position: "top-right",
 defaultDuration: 5000,
};

/** Duration presets by type */
export const DURATION_BY_TYPE: Record<NotificationType, number> = {
 success: 4000,
 info: 5000,
 warning: 6000,
 error: 8000,
 system: 7000,
 security: 10000,
 task: 5000,
 project: 5000,
 leave: 5000,
 time: 5000,
};
